import React from "react";
import { useLocation } from "react-router-dom";

import InviteCustomerFlow from "../../Login/InviteCustomerFlow";
import StatusPage from "../StatusPage";

export default function InviteFormController({ history }) {
  const { pathname } = useLocation();

  if (pathname === "/invite-customer") {
    return <InviteCustomerFlow history={history} />;
  }

  if (pathname.includes("success")) {
    return (
      <StatusPage
        status="success"
        title="Invite Successful"
        history={history}
        showInviteButton
      />
    );
  }

  return null;
}
